/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 8/25/20
 *
 */

import BaseDocSignElement from "@/core/modules/DocSign/data/elements/BaseDocSignElement";
import DocSignElementType from "@/core/modules/DocSign/data/DocSignElementType";

export default class DocSignSignatureElement extends BaseDocSignElement{


	signatureData: string = null
	itemType: DocSignElementType = DocSignElementType.SIGNATURE


	constructor(left: number, top: number, width: number, height: number, type: string = DocSignElementType.SIGNATURE) {
		super(left, top, width, height, type);
	}

	isFilledIn(){
		return this.signatureData && this.signatureData.length > 0
	}

	shouldDeleteOnBackspace(){
		return true
	}

}
